// extracted by mini-css-extract-plugin
export default {"faq":"FAQ_faq__aIHHO","title":"FAQ_title__ALWLR","wrapper":"FAQ_wrapper__TV4OI"};